import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { useStoreActions } from '~/store/store-context';
export const useAdHocScheduledData = (relationshipId, date)=>{
    const { api } = useStoreActions();
    const { data, isLoading } = useQueryState({
        queryKey: [
            QueryKeys.AdHocScheduledData,
            relationshipId,
            date
        ],
        queryFn: ()=>api.billing.getAdHocScheduledData(relationshipId, date),
        enabled: !!relationshipId && !!date
    });
    return {
        scheduledData: data,
        isLoading
    };
};
